import { BALL, CAR, uuToSim } from '../config';

export interface TrainingDefinition {
  readonly takePossessionForwardOffset: number;
  readonly takePossessionVerticalOffset: number;
  readonly dribbleForwardOffset: number;
  readonly dribbleVerticalOffset: number;
  readonly passTargetForwardOffset: number;
  readonly passTargetVerticalOffset: number;
  readonly passSpeed: number;
}

const BALL_ON_CAR_HEIGHT = CAR.halfExtents.y + BALL.radius + uuToSim(8);

const DEFAULT_TRAINING_DEFINITION: TrainingDefinition = Object.freeze({
  takePossessionForwardOffset: CAR.halfExtents.z + BALL.radius + uuToSim(28),
  takePossessionVerticalOffset: BALL.restingHeight - CAR.restingHeight,
  dribbleForwardOffset: uuToSim(12),
  dribbleVerticalOffset: BALL_ON_CAR_HEIGHT,
  passTargetForwardOffset: CAR.halfExtents.z + BALL.radius * 0.4,
  passTargetVerticalOffset: BALL_ON_CAR_HEIGHT,
  passSpeed: uuToSim(1800),
});

export function defaultTrainingDefinition(): TrainingDefinition {
  return DEFAULT_TRAINING_DEFINITION;
}

export function validateTrainingDefinition(definition: TrainingDefinition): void {
  positive(definition.takePossessionForwardOffset, 'take-possession forward offset');
  positive(definition.takePossessionVerticalOffset, 'take-possession vertical offset');
  nonNegative(definition.dribbleForwardOffset, 'dribble forward offset');
  positive(definition.dribbleVerticalOffset, 'dribble vertical offset');
  nonNegative(definition.passTargetForwardOffset, 'pass target forward offset');
  positive(definition.passTargetVerticalOffset, 'pass target vertical offset');
  positive(definition.passSpeed, 'pass speed');
}

function positive(value: number, label: string): void {
  if (!Number.isFinite(value) || value <= 0) throw new Error(`Training ${label} must be a positive finite number.`);
}

function nonNegative(value: number, label: string): void {
  if (!Number.isFinite(value) || value < 0) throw new Error(`Training ${label} must be a non-negative finite number.`);
}
